import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import styles from './PairEditorElement.scss'

import { InputTile, InputSelection, ImageCropper } from 'views/slides/activities/matching_pairs/components'

class InputHolder extends PureComponent {

	constructor() {
		super()
		this.changeTextHandler = this.changeTextHandler.bind(this)
		this.discardContentHandler = this.discardContentHandler.bind(this)
		this.newTextHandler = this.newTextHandler.bind(this)
		this.addAnImageHandler = this.addAnImageHandler.bind(this)
		this.changeImageMatrixHandler = this.changeImageMatrixHandler.bind(this)
		this.imageLoadHandler = this.imageLoadHandler.bind(this)
	}

	changeTextHandler(value) {
		this.props.changeTextHandler(value, this.props.cardName)
	}

	discardContentHandler() {
		this.props.discardContentHandler(this.props.cardName)
	}

	newTextHandler() {
		this.props.newTextHandler(this.props.cardName)
	}

	addAnImageHandler() {
		this.props.addAnImageHandler(this.props.cardName)
	}

	changeImageMatrixHandler(newMatrix) {
		this.props.changeImageMatrixHandler(newMatrix, this.props.cardName)
	}

	imageLoadHandler(width, height) {
		this.props.imageLoadHandler(width, height, this.props.cardName)
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.value.type && this.props.value.type === 'text' && this.element) {
			this.element.focus()
		}
	}

	render() {
		return (
			<div
				styleName={
					cn({
						InputHolder: true,
						'InputHolder--disabled': this.props.disabled,
						error: this.props.pairStatus.error,
					})
				}
			>
				{ this.props.value.type === 'text' &&
					<InputTile
						ref={elem => this.element=elem}
						value={this.props.value.value}
						changeTextHandler={this.changeTextHandler}
						discardContentHandler={this.discardContentHandler}
					/>
				}
				{ this.props.value.type === 'image' &&
					<ImageCropper
						value={this.props.value.value}
						changeImageMatrixHandler={this.changeImageMatrixHandler}
						discardContentHandler={this.discardContentHandler}
						imageLoadHandler={this.imageLoadHandler}
					/>
				}
				{ (this.props.value.type === '' || this.props.value.type === null) &&
					<InputSelection
						addAnImageHandler={this.addAnImageHandler}
						newTextHandler={this.newTextHandler}
					/>
				}
				{this.props.pairStatus.error && <div styleName="InputHolder-errorMessage">{this.props.pairStatus.message}</div>}
			</div>
		)
	}
}

InputHolder.defaultProps = {
	disabled: false,
}

export default CSSModules(InputHolder, styles, { allowMultiple: true })
